import React, {Component} from 'react'
// import PropTypes from 'prop-types'
import {Checkbox, Radio} from 'antd'
import './index.scss'

class CCheckbox extends Component{

  constructor(props) {
    super(props);
    this.changeHandler = this.changeHandler.bind(this);
  }


  state = {
    value: []
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value
    });
  }

  changeHandler(e){
    let value = e;
    this.setState({
      value: value
    });
    this.props.onChange && this.props.onChange(value);
  }

  componentWillMount(){
    let value = this.props.value || false;
    this.setState({
      value: value
    })
  }

  render(){
    const {onChange, ...props} = this.props;
    return (
        <Checkbox.Group onChange={(e) => this.changeHandler(e)} value={this.state.value}>
          {
            this.props.options.map((item=>{
              return<Checkbox key={item.value} checked={this.state.value} value={item.value}>{item.name}</Checkbox>
            }))
          }
        </Checkbox.Group>
    )
  }
}

export default CCheckbox
